module.exports = __webpack_public_path__ + "static/media/hopster.b9b93c14.svg";